import getHelper from '../../../services/getHelper';

import Playlist from '../types/Playlist';

export default getHelper<Playlist>('/playlists/:id', {
  items: getHelper('/items'),
  assignments: getHelper('/assignments'),
});
